import React, {useCallback, useEffect} from 'react';
import classNames from 'classnames';
import ResponseInlineEditContainer from '../forms/ResponseInlineEditContainer';
import IssueFieldInlineEdit from '../forms/IssueFieldInlineEdit';
import {issueAttributesType} from '../../constants/proptype-validation';
import {viewTypes} from '../../constants/view-types';
import PropTypes from 'prop-types';
import {fetchAttachmentsAction, showAttachmentsInGallery} from '../../app/actions';
import {getAttachmentsIssueId, getAttachmentsList, getCurrentViewType} from '../../app/selectors';
import {connect} from '../../app/connect';
import IssuePreviewDetailsTabAttachmentsSection from './IssuePreviewDetailsTabAttachmentsSection';
import DescriptionInlineEdit from '../forms/DescriptionInlineEdit';

const IssuePreviewDetailsTabBottomSection = ({
  issue,
  viewType,
  attachmentIssueId,
  attachments,
  dispatch,
  container
}) => {
  const formClassNames = classNames('IssuePreviewDetailsTabBottomSection', {
    'IssuePreviewDetailsTabBottomSection--narrow': viewType === viewTypes.DOCUMENT,
    'IssuePreviewDetailsTabBottomSection--wide': viewType === viewTypes.PROJECT
  });
  const inlineEditStyleType =
    viewType === viewTypes.DOCUMENT ? IssueFieldInlineEdit.StyleTypes.SMALL : IssueFieldInlineEdit.StyleTypes.DEFAULT;

  const shouldShowAttachments =
    attachmentIssueId === issue.id && attachments.length > 0 && viewType === viewTypes.PROJECT;
  const onClickThumbnail = useCallback((...args) => dispatch(showAttachmentsInGallery(...args)), [dispatch]);

  useEffect(() => {
    dispatch(fetchAttachmentsAction({issueId: issue.id, offset: 0}));
  }, [dispatch, issue.id]);

  return (
    <form className={formClassNames}>
      <DescriptionInlineEdit
        issue={issue}
        className="IssuePreviewDetailsTabTitleSection__field"
        styleType={inlineEditStyleType}
      />
      <ResponseInlineEditContainer
        issue={issue}
        className="IssuePreviewDetailsTabTitleSection__field"
        styleType={inlineEditStyleType}
      />
      {shouldShowAttachments && (
        <IssuePreviewDetailsTabAttachmentsSection
          issue={issue}
          onClickThumbnail={onClickThumbnail}
          container={container}
        />
      )}
    </form>
  );
};

IssuePreviewDetailsTabBottomSection.displayName = 'IssuePreviewDetailsTab';

IssuePreviewDetailsTabBottomSection.propTypes = {
  issue: issueAttributesType,
  viewType: PropTypes.string,
  showAttachmentsInGallery: PropTypes.func.isRequired,
  attachmentIssueId: PropTypes.string,
  attachments: PropTypes.array,
  container: PropTypes.object,
  dispatch: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  viewType: getCurrentViewType(state),
  attachments: getAttachmentsList(state),
  attachmentIssueId: getAttachmentsIssueId(state)
});

export default connect(mapStateToProps)(IssuePreviewDetailsTabBottomSection);
